import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '2rem'
  },

  input: {
    outline: 'none',
    marginRight: '0.5rem',
    border: 'none',
    borderBottom: '1px solid black',
    width: '50%',
    paddingBottom: '0.25rem',
    fontSize: theme.size.sm
  },

  button: {
    width: '64px',
    height: '28px',
    fontSize: theme.size.sm
  },

  checkbox: {
    margin: '0 1rem'
  }
}))

export default useStyles
